const VideoPlayerEvent = {
    PLAYBACK_FINISHED: "VideoPlaybackFinished",
    PLAYBACK_READY: "VideoPlaybackReady",
    PLAYBACK_ERROR: "VideoPlaybackError",
};

export default VideoPlayerEvent;